import React, { useState } from "react";
import { Link } from "react-router-dom";
import purpose from "../../assets/img/empty.png"

function Purpose({isOpen, onDimHover, categoryList, onMenuClick}){
  const [hoveredSubCategory, setHoveredSubCategory] = useState(null);

  if (!isOpen) return null;

  // Purpose 카테고리 찾기
  const purposeCategory = categoryList?.find(category => category.category_name === 'PURPOSE');
  const purposeSubCategories = purposeCategory?.category2 || [];

  // 닫기 버튼 클릭 핸들러 추가
  const handleClose = () => {
    if (onDimHover) {
      onDimHover();
    }
  };

  // 텍스트 줄임표 처리를 위한 인라인 스타일
  const ellipsisStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word',
    lineHeight: '1.2',
    height: 'calc(1.2em * 2)',
    textAlign: 'left',
    alignItems: 'center',
    display: 'flex',
  };

  return(
    <div>
      {/* pc purpose 드롭다운 메뉴 */}
      <div className="dropdown_menu header_ctg purpose_drop">
        <div style={{width: '100%', background: 'rgb(255, 255, 255)'}} onMouseLeave={onDimHover}>
          <div className="inner">
            <div className="brand_navi purpose_navi">
              <div className="main_tit">PURPOSE</div>
                <ul className="purpose_list">
                  {purposeSubCategories.map((subCategory) => (
                    <li key={subCategory.category_seq}>
                      <Link 
                        to={{
                          pathname: '/category/purpose',
                          search: `?title=${encodeURIComponent(subCategory.category_name)}`
                        }}
                        state={{
                          hoveredSubCategory,
                          // purposeSubCategories
                        }}
                        onMouseEnter={() => setHoveredSubCategory(subCategory)}
                        onClick={() => {
                          if (onMenuClick) onMenuClick('Purpose'); // 클릭된 메뉴 노란박스
                          handleClose();
                        }}
                      >
                        <img 
                          src={subCategory.mobile_img_url || purpose}
                          alt={subCategory.category_name} 
                          className="object-contain"
                          loading="lazy"
                        />
                        <span className="sub_tit" style={ellipsisStyle}>
                          {subCategory.category_name}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
            </div>
          </div>
        </div>
        <div className="menu_dim"></div>
      </div>

      {/* mobile purpose 드롭다운 메뉴 */}
      <div className="header_ctg mo_brand">
        <div className="mo_parent">
            <div className="mo_brand_inner">
              <div className="inner">
                <div className="side_top">
                  <button 
                      className="close_btn" 
                      type="button" 
                      onClick={handleClose} 
                  />         
                </div>
                <div className="brand_navi purpose_navi">
                  <div className="main_tit">PURPOSE</div>
                    <ul className="purpose_list">
                      {purposeSubCategories.map((subCategory) => (
                        <li key={subCategory.category_seq}>
                          <Link 
                            to={{
                              pathname: '/category/purpose',
                              search: `?title=${encodeURIComponent(subCategory.category_name)}`
                            }}
                            state={{
                              categoryList,
                              hoveredSubCategory,
                              purposeSubCategories
                            }}
                            onMouseEnter={() => setHoveredSubCategory(subCategory)}
                            onClick={handleClose} 
                          >
                            <img 
                              src={subCategory.mobile_img_url || purpose}
                              alt={subCategory.category_name}
                              className="object-contain"
                              loading="lazy"
                            />
                            <span className="sub_tit" style={ellipsisStyle}>
                              {subCategory.category_name}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                </div>
              </div>
            </div>
        </div>
        <div className="menu_dim"  onClick={handleClose}></div>
      </div>

    </div>
  )
};

export default Purpose;